<form [formGroup]="contactForm" (ngSubmit)="onSubmit()">
  <div class="form-row">
    <div class="form-group">
      <app-input
        [form]="contactForm"
        formGroupName="firstName"
        placeHolder="First Name"
      ></app-input>
    </div>
    <div class="form-group">
      <app-input
        [form]="contactForm"
        formGroupName="lastName"
        placeHolder="Last Name"
      ></app-input>
    </div>
  </div>

  <p class="contact-hint noselect">Please provide at least one way to reach you.</p>

  <div class="form-row">
    <div class="form-group">
      <app-input
        [form]="contactForm"
        formGroupName="email"
        placeHolder="Email"
        inputType="email"
      ></app-input>
    </div>
    <div class="form-group">
      <app-input
        [form]="contactForm"
        formGroupName="phone"
        placeHolder="Phone Number"
        inputType="tel"
      ></app-input>
    </div>
  </div>

  <div *ngIf="contactMethodMissing" class="contact-method-error noselect">
    Please enter an email address or phone number.
  </div>

  <div class="form-group">
    <textarea
      class="message-input"
      formControlName="message"
      placeholder="Describe your issue or question (optional)"
      rows="4"
    ></textarea>
  </div>

  <div class="form-actions noselect">
    <button
      *ngIf="showCancel"
      type="button"
      class="btn btn-secondary"
      (click)="onCancel()"
      [disabled]="isSubmitting"
    >
      Cancel
    </button>
    <button type="submit" class="btn btn-primary" [disabled]="isSubmitting">
      <span *ngIf="!isSubmitting">Send Message</span>
      <span *ngIf="isSubmitting">
        <span class="spinner-small"></span> Sending...
      </span>
    </button>
  </div>
</form>
